// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2u5Wo","list":"PatternAutocomplete_list__3dYrr"};